/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelDeliveryReasonAdminDto } from '../models/CancelDeliveryReasonAdminDto';
import type { CancelDeliveryReasonAdminListedDtoAdmin } from '../models/CancelDeliveryReasonAdminListedDtoAdmin';
import type { PostPutCancelDeliveryReasonAdminRequest } from '../models/PostPutCancelDeliveryReasonAdminRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CancelDeliveryReasonsService {
    /**
     * **Required Policy:** `ViewCancelDeliveryReasons`
     * @returns CancelDeliveryReasonAdminDto OK
     * @throws ApiError
     */
    public static getCancelDeliveryReasonByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CancelDeliveryReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/canceldeliveryreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelDeliveryReasons`
     * @returns CancelDeliveryReasonAdminDto OK
     * @throws ApiError
     */
    public static putCancelDeliveryReasonAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PostPutCancelDeliveryReasonAdminRequest,
    }): CancelablePromise<CancelDeliveryReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/canceldeliveryreasons/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCancelDeliveryReasons`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCancelDeliveryReasonAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/canceldeliveryreasons/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCancelDeliveryReasons`
     * @returns CancelDeliveryReasonAdminListedDtoAdmin OK
     * @throws ApiError
     */
    public static getCancelDeliveryReasonsAdmin({
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Array<CancelDeliveryReasonAdminListedDtoAdmin>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/canceldeliveryreasons',
            query: {
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCancelDeliveryReasons`
     * @returns CancelDeliveryReasonAdminDto Created
     * @throws ApiError
     */
    public static postCancelDeliveryReasonAdmin({
        requestBody,
    }: {
        requestBody?: PostPutCancelDeliveryReasonAdminRequest,
    }): CancelablePromise<CancelDeliveryReasonAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/canceldeliveryreasons',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
